import { render, staticRenderFns } from "./android.vue?vue&type=template&id=afb1540e&scoped=true&"
import script from "./android.vue?vue&type=script&lang=ts&"
export * from "./android.vue?vue&type=script&lang=ts&"
import style0 from "./android.vue?vue&type=style&index=0&id=afb1540e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afb1540e",
  null
  
)

export default component.exports